import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";
import HttpApi from 'i18next-http-backend'
import { initReactI18next } from "react-i18next";

import translationEng from "./locales/en/translation.json";
import translationTel from "./locales/te/translation.json";
// import translationFre from "../locales/fre/translation.json";
import translationHin from "./locales/hin/translation.json";
import translationMar from "./locales/mar/translation.json";
import i18next from "i18next";
// import translationJap from "../locales/jap/translation.json";
i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'hin', 'te', 'mar'],
    debug: false,
    //lng: "en",
    fallbackLng: "en", // use en if detected lng is not available

    detection: {
      order: ['cookie','path','htmlTag', 'localStorage'],
      caches: ['cookie'],
    },

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    },
    backend: {
      loadPath: 'locales/{{lng}}/translation.json',
    },
    resources: {
      en: {
        translations: translationEng
      },
  
      hin: {
        translations: translationHin
      },

      te: {
        translations: translationTel
      },
      mar: {
        translations: translationMar
      }
    },
    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations"
  });

export default i18n;
